var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevOps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,14h3v2H1v14h3v2H1v14h3v4h42v-4h3V32h-3v-2h3V16h-3v-2h3V0H1V14z M44,48H6v-2h38V48z M47,34v10h-1H4H3V34h1h42H47z  M44,32H6v-2h38V32z M47,18v10h-1H4H3V18h1h42H47z M44,16H6v-2h38V16z M3,2h44v10h-1H4H3V2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 6,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 37,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 38,
    width: 13,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOps);
export default __webpack_public_path__ + "static/media/dev_ops.5b3400b9a51a71e5592595af1ce872de.svg";
export { ForwardRef as ReactComponent };